/* eslint-disable react/jsx-key */
/* eslint-disable react/prop-types */
// @ts-nocheck

import React from 'react';

export function CommentsListItem() {
  return <>comments-list-item</>;
}

// import { naturalShortTime } from '../../utils/date-utils';

// import theme from '../../themes/default';
// import { t } from '../../locales/i18n';
// import Icon from '../icon';
// import { getDateFromValidityKey } from '../../utils/date-utils';
// import { Button } from 'semantic-ui-react';

// const colors = theme.palette;

// export class ListItem extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       dialogKey: null,
//       selectedValidity: 'today',
//       updatedText: props.text
//     };
//   }

//   handleOpenDialog(dialogKey) {
//     this.setState({ dialogKey });
//   }

//   handleCloseDialog() {
//     this.setState({ dialogKey: null });
//   }

//   handleSubmitDialog(dialogKey) {
//     switch (dialogKey) {
//       case 'deleteComment': {
//         this.props.onCommentDelete(this.props.id);
//         break;
//       }
//       case 'editComment': {
//         this.props.onCommentUpdate({
//           id: this.props.id,
//           text: this.state.updatedText
//         });
//         break;
//       }
//       case 'changeVisibility': {
//         this.props.onCommentUpdate({ id: this.props.id, visibility: 'all' });
//         break;
//       }
//       case 'changeValidity': {
//         const validUntil = getDateFromValidityKey(this.state.selectedValidity);
//         this.props.onCommentUpdate({ id: this.props.id, validUntil });
//       }
//     }
//     this.handleCloseDialog();
//   }

//   renderDialogButtons(dialogKey) {
//     return [
//       <Button variant="flat" primary={false} onClick={() => this.handleCloseDialog()}>
//         {t('button.cancel')}
//       </Button>,
//       <Button variant="flat" primary={true} keyboardFocused={true} onClick={() => this.handleSubmitDialog(dialogKey)}>
//         {t('button.ok')}
//       </Button>
//     ];
//   }

//   renderActionIcons() {
//     const { props } = this;
//     const visibilityColor = props.visibility === 'all' ? colors.primary1Color100 : colors.grey200;
//     return (
//       <div>
//         <span>
//           <Icon color={colors.grey300} name="today" />
//           <span>{props.validUntilData.title}</span>
//         </span>
//         <span>
//           <Icon color={visibilityColor} name="visibility" />
//           <span>{props.visibilityData.title}</span>
//         </span>
//       </div>
//     );
//   }

//   renderEditCommentMI() {
//     return (
//       <MenuItem primaryText={t('commentListItem.editComment')} onClick={() => this.handleOpenDialog('editComment')} />
//     );
//   }

//   renderDeleteCommentMI() {
//     return (
//       <MenuItem
//         style={{ color: colors.errorColor }}
//         primaryText={t('commentListItem.deleteComment')}
//         onClick={() => this.handleOpenDialog('deleteComment')}
//       />
//     );
//   }

//   renderChangeVisibilityMI() {
//     const { props } = this;
//     const { visibilityData, simpleView } = props;
//     if (simpleView || visibilityData.key !== 'queue') {
//       return false;
//     }
//     return (
//       <MenuItem
//         primaryText={t('commentListItem.changeVisibility')}
//         onClick={() => this.handleOpenDialog('changeVisibility')}
//       />
//     );
//   }

//   renderChangeValidityMI() {
//     const { props } = this;
//     const { simpleView } = props;
//     if (simpleView) {
//       return false;
//     }
//     return (
//       <MenuItem
//         primaryText={t('commentListItem.changeValidity')}
//         onClick={() => this.handleOpenDialog('changeValidity')}
//       />
//     );
//   }

//   renderActionBar() {
//     const { props } = this;
//     const { simpleView, author } = props;
//     const fullView = !simpleView;
//     if (author !== 'booth') {
//       return false;
//     }
//     return (
//       <div>
//         {fullView && this.renderActionIcons()}
//         <Menu
//           iconButtonElement={<Button></Button>}
//           anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
//           targetOrigin={{ horizontal: 'right', vertical: 'top' }}
//         >
//           {this.renderEditCommentMI()}
//           {this.renderDeleteCommentMI()}
//           {this.renderChangeValidityMI()}
//           {this.renderChangeVisibilityMI()}
//         </Menu>
//       </div>
//     );
//   }

//   render() {
//     const { props } = this;
//     const authoredByUs = props.author === 'booth';
//     const authorTitle = authoredByUs ? '' : props.ticketDisplayName;
//     return (
//       <li>
//         <section>
//           <section>
//             {authoredByUs && <Icon color={colors.primary1Color100} name="comment" />}
//             {!authoredByUs && <Avatar>{authorTitle}</Avatar>}
//           </section>
//           <section>
//             <section>
//               <time>
//                 <span>{naturalShortTime(props.createdOn)}</span>
//               </time>
//               {this.renderActionBar()}
//             </section>
//             <section>{props.text}</section>
//           </section>
//         </section>
//         <Dialog
//           title={t('dialog.editComment.title')}
//           actions={this.renderDialogButtons('editComment')}
//           modal={false}
//           open={this.state.dialogKey === 'editComment'}
//           onRequestClose={() => this.handleCloseDialog()}
//         >
//           <div>{t('dialog.editComment.message')}</div>
//           <div>
//             <textarea
//               value={this.state.updatedText}
//               onChange={(event) => this.setState({ updatedText: event.target.value })}
//             />
//           </div>
//         </Dialog>
//         <Dialog
//           title={t('dialog.deleteComment.title')}
//           actions={this.renderDialogButtons('deleteComment')}
//           modal={false}
//           open={this.state.dialogKey === 'deleteComment'}
//           onRequestClose={() => this.handleCloseDialog()}
//         >
//           <div>{this.props.text}</div>
//         </Dialog>
//         <Dialog
//           title={t('dialog.changeVisibility.title')}
//           actions={this.renderDialogButtons('changeVisibility')}
//           modal={false}
//           open={this.state.dialogKey === 'changeVisibility'}
//           onRequestClose={() => this.handleCloseDialog()}
//         >
//           <div>{t('dialog.changeVisibility.message')}</div>
//         </Dialog>
//         <Dialog
//           title={t('dialog.changeValidity.title')}
//           actions={this.renderDialogButtons('changeValidity')}
//           modal={false}
//           open={this.state.dialogKey === 'changeValidity'}
//           onRequestClose={() => this.handleCloseDialog()}
//         >
//           <TextField
//             select
//             label={t('validUntil.title')}
//             value={this.state.selectedValidity}
//             onChange={(event, index, value) => this.setState({ selectedValidity: value })}
//           >
//             <MenuItem value={'today'}>{t('validUntil.today')}</MenuItem>
//             <MenuItem value={'tomorrow'}>{t('validUntil.tomorrow')}</MenuItem>
//             <MenuItem value={'forever'}>{t('validUntil.forever')}</MenuItem>
//           </TextField>
//           <div>{t('dialog.changeValidity.message')}</div>
//         </Dialog>
//       </li>
//     );
//   }
// }
